import { createGlobalStyle } from 'styled-components';

import { baseGlobalStyles } from './base';

export const GlobalStyles = createGlobalStyle`
  /* TODO: Add global style reset file? */
  ${baseGlobalStyles}
`;
